import './App.css';

import Calculator from './components/calculator/Calculator';

function App() {
  return (
    <Calculator />
  );
}

export default App;
